/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'cross-flow-support.back-to-all-products': 'Zurück zu allen Apps',
  'cross-flow-support.close': 'Schließen',
  'cross-flow-support.product-store': 'App-Store',
};
